import React from 'react';
import { cn } from '../utils';

export interface GridProps {
  cols?:
    | number
    | string
    | { sm?: number | string; md?: number | string; lg?: number | string; xl?: number | string };
  gap?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
  children: React.ReactNode;
}

export const Grid: React.FC<GridProps> = ({ cols = 1, gap = 'md', className, children }) => {
  const gapClasses = {
    xs: 'gap-1',
    sm: 'gap-2',
    md: 'gap-4',
    lg: 'gap-6',
    xl: 'gap-8',
  };

  const getColClasses = () => {
    if (typeof cols === 'number' || typeof cols === 'string') {
      return `grid-cols-${cols}`;
    }

    const responsive = [];
    if (cols.sm) responsive.push(`sm:grid-cols-${cols.sm}`);
    if (cols.md) responsive.push(`md:grid-cols-${cols.md}`);
    if (cols.lg) responsive.push(`lg:grid-cols-${cols.lg}`);
    if (cols.xl) responsive.push(`xl:grid-cols-${cols.xl}`);

    return ['grid-cols-1', ...responsive].join(' ');
  };

  return <div className={cn('grid', getColClasses(), gapClasses[gap], className)}>{children}</div>;
};
